import { getPropertiesByProject } from "./Properties.service";

export async function getPropertiesByProjectRepository(projectId, params) {
  const response = await getPropertiesByProject(projectId, params);
  
  return {
    resources: response.data?.resources || [],
    count: response.data?.count || 0
  };
}
